import { Linkedin, Mail } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0B132B] text-[#F0ECE1] py-16 px-6 sm:px-10 lg:px-16"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-6">
            <p className="font-serif text-3xl text-[#F0ECE1]">
              Olivier Soutarson
            </p>
            <p className="mt-3 text-[#F0ECE1]/70 font-light max-w-md leading-relaxed">
              DSI de transition — Manager de transition IT.
            </p>
            <p className="mt-2 text-[#F0ECE1]/70 font-light max-w-md leading-relaxed">
              Je sécurise, je structure, je remets en mouvement.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow mb-4">Contact</p>
            <a
              href="mailto:olivier@soutarson.fr"
              data-testid="footer-email"
              className="flex items-center gap-2 text-[#F0ECE1] hover:text-[#C8A97E] transition-colors font-light"
            >
              <Mail size={15} />
              olivier@soutarson.fr
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow mb-4">Suivre</p>
            <a
              href="https://www.linkedin.com/in/olivier-g-soutarson/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin"
              className="flex items-center gap-2 text-[#F0ECE1] hover:text-[#C8A97E] transition-colors font-light"
            >
              <Linkedin size={15} />
              LinkedIn
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#F0ECE1]/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-[#F0ECE1]/55 tracking-wide">
            © {new Date().getFullYear()} Olivier Soutarson. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/mentions-legales"
              data-testid="footer-legal-link"
              className="text-xs text-[#F0ECE1]/55 hover:text-[#C8A97E] tracking-wide transition-colors"
            >
              Mentions légales
            </Link>
            <p className="text-xs text-[#F0ECE1]/55 italic hidden md:block">
              « L'urgentiste IT qu'on appelle quand le SI est en détresse. »
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
